/** The version of Donwinne, kept equal to the "version" in the package.json files (a test checks it). */
export const APP_VERSION = "0.3.0";
